import React from 'react'
import {Header} from "../../../header/Header";

export const NotifierApp = () => {
    return (
        <>
            <Header />
            <div className="container">
                <div className="row mt-4 d-flex justify-content-between align-items-center">
                    <div className="col-lg-8 offset-lg-2 col-12 text-center">
                        <h2 style={{fontFamily: 'Segoe UI",Arial,sans-serif', fontWeight: '400'}}>Zynity Notifier</h2>
                        <div style={{width: '50%', height: '4px', backgroundColor: 'lightgreen', marginLeft: 'auto', marginRight: 'auto'}} />
                    </div>
                    <div className="col-lg-8 offset-lg-2 col-12 mt-3">
                        <p>The <b>Zynity Notifier App</b>, also known as <i>Zynity Team Update</i>, is designed to provide real-time notifications on your personal device whenever team members add new items. It works seamlessly with the <b>Team Collab app</b> and the <b>Meeting Collab app</b>, helping you stay in sync without missing a beat.</p>

                        <p>Zynity Notifier is available for <b><a href="https://www.microsoft.com/store/productId/9NHDZRJ05NP3?ocid=pdpshare" target='_blank'>Windows</a>, <a
                            href="https://apps.apple.com/mx/app/zynity-team-updates/id1567160071" target='_blank'>MacOS</a>, <a
                            href="https://play.google.com/store/apps/details?id=com.zynity.z_team_updates" target='_blank'>Android</a>,</b> and <b><a
                            href="https://apps.apple.com/mx/app/zynity-team-updates/id1567160071" target='_blank'>iPhone</a>.</b>
                        </p>

                        <p>To download the app, select your operating system below and follow the instructions. Once installed, log in using your Zynity credentials and stay informed about member activity.</p>

                        <div className="alert alert-secondary" role="alert">
                            <i className="bi bi-info-circle-fill me-2"></i>
                            <strong>Note:</strong> On some systems, especially if auto-update is not enabled, it may be necessary to uninstall the previous version of the app before installing the latest one. If prompted, simply remove the older version and proceed with the new installation.
                        </div>

                        <div className="alert alert-warning" role="alert">
                            <i className="bi bi-bell-fill me-2"></i>
                            <strong>Important:</strong> After logging in, make sure notifications are enabled for Zynity Notifier on your device. If notifications are turned off, you won’t receive real-time updates.
                        </div>

                        <div className="card mb-4">
                            <div className="card-header bg-light">
                                <i className="bi bi-windows me-2"></i><b>Windows</b>
                            </div>
                            <div className="card-body">
                                <ol className='ms-3'>
                                    <li>Access the Microsoft Store using your device.</li>
                                    <li>Search for "zynity" and click to install when ‘Zynity Notifier’ shows in the list.</li>
                                    <li>Follow the instructions/prompts.</li>
                                    <li>Open the app and log in.</li>
                                    <li>Check your system settings to ensure notifications are allowed for Zynity Notifier.</li>
                                </ol>
                            </div>
                        </div>

                        <div className="card mb-4">
                            <div className="card-header bg-light">
                                <i className="bi bi-apple me-2"></i><b>MacOS</b>
                            </div>
                            <div className="card-body">
                                <ol className='ms-3'>
                                    <li>Access the Mac App Store using your device.</li>
                                    <li>Search for "zynity" and click to install when ‘Zynity Notifier’ shows in the list.</li>
                                    <li>Follow the instructions/prompts.</li>
                                    <li>Open the app and log in.</li>
                                    <li>Go to System Settings &gt; Notifications and enable alerts for Zynity Notifier.</li>
                                </ol>
                            </div>
                        </div>

                        <div className="card mb-4">
                            <div className="card-header bg-light">
                                <i className="bi bi-android2 me-2"></i><b>Android</b>
                            </div>
                            <div className="card-body">
                                <ol className='ms-3'>
                                    <li>Access the Android Play store using your mobile device.</li>
                                    <li>Search for "zynity" and click to install when ‘Zynity Notifier’ shows in the list.</li>
                                    <li>Follow the instructions/prompts.</li>
                                    <li>Open the app and log in.</li>
                                    <li>Go to Settings &gt; Apps &gt; Zynity Notifier &gt; Notifications, and turn them on.</li>
                                </ol>
                            </div>
                        </div>

                        <div className="card mb-5">
                            <div className="card-header bg-light">
                                <i className="bi bi-phone me-2"></i><b>iPhone</b>
                            </div>
                            <div className="card-body">
                                <ol className='ms-3'>
                                    <li>Access the iPhone App store using your mobile device.</li>
                                    <li>Search for "zynity" and click to install when ‘Zynity Notifier’ shows in the list.</li>
                                    <li>Follow the instructions/prompts.</li>
                                    <li>Open the app and log in.</li>
                                    <li>Open Settings &gt; Notifications &gt; Zynity Notifier, and allow alerts.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
